module.exports = __webpack_public_path__ + "img/project-3save.125e7ae9.jpg";